import React, { useState, useEffect } from 'react';
import { Modal, Box, Button, Typography, FormControl, Select, MenuItem, InputLabel, IconButton, Stack } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';

const AssignSpecificLinkCategoryModalToAccountCategory = ({ open, onClose, category }) => {
    const [linkCategories, setLinkCategories] = useState([]);
    const [selectedLinkCategory, setSelectedLinkCategory] = useState('');
    const [assignedLinkCategories, setAssignedLinkCategories] = useState([]);

    useEffect(() => {
        if (open) {
            fetchLinkCategories();
            fetchAssignedLinkCategories();
        }
    }, [open]);

    const fetchLinkCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}specific-link-category/all`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setLinkCategories(response.data);
        } catch (error) {
            toast.error('Failed to fetch Link categories');
            console.error(error);
        }
    };

    const fetchAssignedLinkCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}category/${category.id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setAssignedLinkCategories(response.data.specificLinkCategories || []);
        } catch (error) {
            toast.error('Failed to fetch assigned Link categories');
            console.error(error);
        }
    };

    const handleAssign = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}category/assign-specific-link-category`, {
                categoryId: category.id,
                specificLinkCategoryId: selectedLinkCategory
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success('Specific Link category assigned successfully');
            setSelectedLinkCategory('');
            fetchAssignedLinkCategories();
        } catch (error) {
            toast.error('Failed to assign Specific Link category');
            console.error(error);
        }
    };

    const handleRemove = async (linkCategoryId) => {
        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}category/remove-specific-link-category`, {
                categoryId: category.id,
                specificLinkCategoryId: linkCategoryId._id
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            toast.success('Specific Link category removed successfully');
            setAssignedLinkCategories(prev => prev.filter(id => id !== linkCategoryId));
        } catch (error) {
            toast.error('Failed to remove Specific Link category');
            console.error(error);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 450,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                color: 'black'
            }}>
                <Typography variant="h6" sx={{ mb: 2 }}>Assigned Link Categories</Typography>

                {assignedLinkCategories.length === 0 && (
                    <Typography variant="body2" color="text.secondary">No link categories assigned.</Typography>
                )}

                <Stack spacing={1} sx={{ mb: 3 }}>
                    {assignedLinkCategories.map((linkCategoryId) => {

                        return (
                            <Box key={linkCategoryId} display="flex" justifyContent="space-between" alignItems="center" border="1px solid #ccc" borderRadius={1} p={1}>
                                <Typography>{linkCategoryId?.categoryName || 'Unknown Category'}</Typography>
                                <IconButton onClick={() => handleRemove(linkCategoryId)} size="small" color="error">
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                        );
                    })}
                </Stack>

                <Typography variant="h6" sx={{ mb: 2 }}>Assign New Link Category</Typography>
                <FormControl fullWidth>
                    <InputLabel>Select Link Category</InputLabel>
                    <Select
                        value={selectedLinkCategory}
                        label="Select Link Category"
                        onChange={(e) => setSelectedLinkCategory(e.target.value)}
                    >
                        {linkCategories.map((cat) => (
                            <MenuItem key={cat._id} value={cat._id}>
                                {cat.categoryName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Button variant="contained" onClick={handleAssign} style={{ marginTop: '1rem' }} disabled={!selectedLinkCategory}>
                    Assign
                </Button>
            </Box>
        </Modal>
    );
};

export default AssignSpecificLinkCategoryModalToAccountCategory;
